import React, { Component } from 'react';
import ReactStars from 'react-stars';
import './PlayerFeedback.css';
import { Cancel, Confirm, Text } from '../../buttons';
import { SmallLoading } from '../../common';
import { Select } from '../../inputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class PlayerFeedback extends Component {
	constructor(props) {
		super(props);
		this.state = {
			edit: true,
			tempRating: 0,
			temp: false,
			tempText: 'You',
			ratingId: 0,
			ratings: {
				0: { name: 'Vote', id: 1 },
				1: { name: '0.5', id: 1 },
				2: { name: '1', id: 2 },
				3: { name: '1.5', id: 3 },
				4: { name: '2', id: 4 },
				5: { name: '2.5', id: 5 },
				6: { name: '3', id: 6 },
				7: { name: '3.5', id: 7 },
				8: { name: '4', id: 8 },
				9: { name: '4.5', id: 9 },
				10: { name: '5', id: 10 },
				11: { name: '5.5', id: 11 },
				12: { name: '6', id: 12 },
				13: { name: '6.5', id: 13 },
				14: { name: '7', id: 14 },
				15: { name: '7.5', id: 15 },
				16: { name: '8', id: 16 },
				17: { name: '8.5', id: 17 },
				18: { name: '9', id: 18 },
				19: { name: '9.5', id: 19 },
				20: { name: '10', id: 20 },
			},
			ratingsById: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
		};
		this.onRatingUserConfirm = this.onRatingUserConfirm.bind(this);
		this.onRatingUserChangeSelect = this.onRatingUserChangeSelect.bind(this);
	}

	onRatingChange = val => {
		this.props.onRatingChange(val);
	};

	onRatingUserChange = val => {
		this.setState({
			tempRating: val,
			temp: true,
			tempText: 'You',
		});
	};

	onRatingUserChangeSelect = val => {
		this.setState({
			tempRating: Number(parseFloat(this.state.ratings[val].name).toFixed(1)),
			temp: true,
			tempText: 'You',
		});
	};

	onRatingUserConfirm = () => {
		this.props.onUserRatingChange(this.state.tempRating);
		this.setState({
			tempRating: 0,
			temp: false,
			tempText: 'You',
			edit: false,
		});
	};

	onReviewChange = e => {
		this.props.onReviewChange(e.target.value);
	};

	_isNan = val => (isNaN(val) ? 0 : val);

	_renderUserStars = () => {
		if (this.state.temp) {
			return (
				<div className="item-large">
					<div className="flexContainerRow">
						<div className="item-1">
							<span className="ratingScore">{this.state.tempRating}</span>
						</div>
						<div className="item-1 confirmRating borderRight">
							<Cancel
								action={() =>
									this.setState({
										tempRating: 0,
										temp: false,
										edit: true,
										tempText: 'You',
									})
								}
							/>
						</div>
						<div className="item-1 confirmRating">
							<Confirm action={this.onRatingUserConfirm} />
						</div>
					</div>
				</div>
			);
		}
		if (this.state.edit) {
			return (
				<div className="item-1">
					<div className="userStarsDesk">
						<ReactStars
							count={10}
							onChange={this.onRatingUserChange}
							size={15}
							value={this.props.playerReport.userRating}
							color1={'#C5C5C5'}
							color2={'#ffc000'}
						/>
					</div>
					<div className="userStarsMob">
						<Select
							prompt="Vote"
							currentVal={this.state.ratingId}
							options={this.state.ratings}
							optionsById={this.state.ratingsById}
							onChange={this.onRatingUserChangeSelect}
						/>
					</div>
				</div>
			);
		}
		return <SmallLoading />;
	};

	render() {
		return (
			<div className="player-feedback">
				{this.props.playerReport.readOnly ? (
					<div>
						<div className="flexContainerRow rating-wrap arsebloRating">
							<div className="item-1 ratingTitle">
								<span>arseblog</span>
							</div>
							<div className="item-large">
								<div className="d">
									<span className="ratingScore">{this.props.playerReport.matchRating}</span>
								</div>
							</div>
							<div className="item-1" />
							<div className="item-large" />
						</div>
						{this.props.userRating ? (
							this.props.hasVoted ? (
								<div className="flexContainerRow">
									<div className="item-1 userRating">
										<div className="flexContainerRow rating-wrap">
											<div className="item-1 ratingTitle">
												<span>You</span>
											</div>
											<div className="item-large">
												<div className="d">
													<span className="ratingScore">{this.props.hasVoted.rating}</span>
												</div>
											</div>
										</div>
									</div>
									<div className="item-1 avgRating">
										<div className="flexContainerRow rating-wrap">
											<div className="item-1 ratingTitle">
												<span>Avg</span>
											</div>
											<div className="item-large">
												<div className="d">
													<span className="ratingScore">
														{this._isNan(
															(
																Math.round(this.props.playerReport.avgUserRating / 0.5) * 0.5
															).toFixed(1),
														)}
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							) : (
								<div className="flexContainerRow">
									<div className="item-1 userRating">
										<div className="flexContainerRow rating-wrap">
											<div className="item-1 ratingTitle">
												<span>{this.state.tempText}</span>
											</div>
											<div className="item-large">
												<div className="item-large userStars">{this._renderUserStars()}</div>
											</div>
										</div>
									</div>
									<div className="item-1 avgRating">
										<div className="flexContainerRow rating-wrap">
											<div className="item-1 ratingTitle">
												<span />
											</div>
											<div className="item-large">
												<div className="d">
													<span className="ratingScore" />
												</div>
											</div>
										</div>
									</div>
								</div>
							)
						) : null}
					</div>
				) : (
					<div className="flexContainerRow star-wrap">
						<div className="item-large stars">
							<ReactStars
								count={10}
								onChange={this.onRatingChange}
								size={20}
								value={this.props.playerReport.onChange.matchRating}
								edit={!this.props.playerReport.readOnly}
								color1={'#C5C5C5'}
								color2={'#ffc000'}
							/>
						</div>
					</div>
				)}
				{this.props.hasVoted ? (
					<div className="flexContainerRow playerMeta">
						<div className="item-1" />
						<div className="item-1">
							<div className="flexContainerRow rating-wrap">
								<div className="item-1" title="Number of votes">
									<FontAwesomeIcon icon="check-circle" />
									<span>
										{this._isNan(this.props.playerReport.userRatingCount).toLocaleString()}
									</span>
								</div>
								<div className="item-1" title="Season average">
									<FontAwesomeIcon icon="chart-line" />
									<span />
								</div>
							</div>
						</div>
					</div>
				) : (
					<div className="flexContainerRow playerMeta">
						<div className="item-1" />
						<div className="item-1">
							<div className="flexContainerRow rating-wrap">
								<div className="item-1" title="Number of votes">
									<span />
								</div>
								<div className="item-1" title="Season average">
									<span />
								</div>
							</div>
						</div>
					</div>
				)}

				<div className="flexContainerRow">
					<div className="item-1 review-wrap">
						<div className="review">
							{!this.props.playerReport.readOnly ? (
								<textarea
									rows="4"
									cols="50"
									readOnly={this.props.playerReport.readOnly}
									value={this.props.playerReport.onChange.review}
									onChange={this.onReviewChange}
								/>
							) : (
								<p>{this.props.playerReport.review}</p>
							)}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export { PlayerFeedback };



// WEBPACK FOOTER //
// ./src/components/cards/playerFeedback/PlayerFeedback.js